import React, { useState } from "react";
import { Row, Col, Input, Button, Checkbox } from "antd";
import { Link, useHistory } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import { signUpUser, oAuth2 } from "../../redux/actions/authentication";
import { connect } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { Controller, useForm } from "react-hook-form";
import { signupCredentialsSchema } from "../validattion";
import { yupResolver } from "@hookform/resolvers/yup";

const Register = (props) => {
  let { signUpUser, oAuth2 } = props;
  let history = useHistory();
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
  } = useForm({
    resolver: yupResolver(signupCredentialsSchema),
  });

  const [errorLog, setErrorLog] = useState({
    first_name: [],
    last_name: [],
    email: [],
    password1: [],
    password2: [],
  });
  const [loading, setLoading] = useState(false);

  const PerformSignup = async (data) => {
    setLoading(true);

    const res = await signUpUser(data);
    if (res.success) {
      reset();
      toast.success(
        "Account created. Please, wait while we redirect you to dashboard",
        {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        }
      );
      setTimeout(() => {
        history.push("/dashboard");
      }, 3000);
    } else {
      setLoading(false);
      setErrorLog(res?.message);
      return toast.error("Something went wrong", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <AuthLayout
        fadeName="fade-left"
        googleLabel="Sign Up"
        pageTitle="Register"
        oAuth2={oAuth2}
      >
        <form onSubmit={handleSubmit(PerformSignup)}>
          <Row gutter={24}>
            <Col xs={24} xl={12} lg={12}>
              <div className="form-group">
                <label>First Name</label>
                <Controller
                  name="first_name"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                <small className="text-danger">
                  {errors.first_name && (
                    <span className="error">{errors.first_name.message}</span>
                  )}
                </small>
              </div>
            </Col>
            <Col xs={24} xl={12} lg={12}>
              <div className="form-group">
                <label>Last Name</label>
                <Controller
                  name="last_name"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                <small className="text-danger">
                  {errors.last_name && (
                    <span className="error">{errors.last_name.message}</span>
                  )}
                </small>
              </div>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <label>User Name</label>
                <Controller
                  name="username"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                <small className="text-danger">
                  {errors.username && (
                    <span className="error">{errors.username.message}</span>
                  )}
                </small>
              </div>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <label>Email Address</label>
                <Controller
                  name="email"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input {...field} />}
                />
                <small className="text-danger">
                  {errors.email && (
                    <span className="error">{errors.email.message}</span>
                  )}
                </small>
              </div>
            </Col>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <label>Password</label>
                <Controller
                  name="password1"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input.Password {...field} />}
                />
                <small className="text-danger">
                  {errors.password1 && (
                    <span className="error">{errors?.password1?.message}</span>
                  )}
                </small>
              </div>
            </Col>
            <Col xs={24} xl={24} lg={24}>
              <div className="form-group">
                <label>Confirm Password</label>
                <Controller
                  name="password2"
                  control={control}
                  defaultValue=""
                  render={({ field }) => <Input.Password {...field} />}
                />
                <small className="text-danger">
                  {errors.password2 && (
                    <span className="error">{errors?.password2?.message}</span>
                  )}
                </small>
              </div>
            </Col>
            {/* <Col xs={24} xl={24} lg={24}>
              <Checkbox>
                <p style={{ fontSize: "0.8rem" }}>
                  I agree to the <a href="/termandcondition">Terms of Use</a>{" "}
                  and <a href="/privacypolicy">Privacy Policy</a> , to the
                  processing of my personal data, and to receive emails
                </p>
              </Checkbox>
            </Col> */}
          </Row>
          <Row gutter={24}>
            <Col xs={24} xl={24} lg={24}>
              <Button loading={loading} block type="primary" htmlType="submit">
                {loading ? "Creating Account..." : "Sign Up"}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={24} xl={24} lg={24}>
              <p className="register">
                Already have account? <Link to="/auth/login">Sign in</Link>
              </p>
            </Col>
          </Row>
        </form>
      </AuthLayout>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth_error: state.authReducer.auth_error,
  };
};

export default connect(mapStateToProps, { signUpUser, oAuth2 })(Register);
